import { ModalProps } from '@withjoy/joykit';

export const dialogOverrides: NonNullable<ModalProps['overrides']> = {
  Content: { props: { overflow: 'hidden' } },
  Header: {
    props: {
      position: 'absolute',
      top: 0,
      right: 0,
      backgroundColor: 'transparent',
      paddingTop: { _: '1rem !important', sm: 5 },
      paddingRight: { _: '1rem !important', sm: 5 },
    },
  },
  Body: { props: { padding: '0 !important' } },
};

export const drawerOverrides: NonNullable<ModalProps['overrides']> = {
  Content: { props: { borderTopLeftRadius: 4, borderTopRightRadius: 4, height: 'auto', maxHeight: 'calc(100vh - 2rem)' } },
  Header: {
    props: {
      position: 'absolute',
      top: 0,
      right: 0,
      backgroundColor: 'transparent',
      paddingTop: '1rem !important',
      paddingRight: '1rem !important',
    },
  },
  Body: { props: { padding: '0 !important' } },
};
